<div class="c-modal c-modal--md" id="modal-{{vm.uid}}">
	<div mat-dialog-content class="c-modal__dialog">
		<div class="c-modal__header">
			<div class="o-grid">
				<div class="o-grid__cell u-no-p">
					<p style="font-size: 22px">{{ 'Booking.Modal.AddReservedTime' | translate }}</p>
				</div>
				<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
					<button id="closeButton" class="c-button c-button--icon c-button--tp c-modal__close" (click)="vm.close()">
						<i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
						<span class="u-sr-only">{{ 'Modal.Button.Close' | translate }}</span>
					</button>
				</div>
			</div>
		</div>
		<div class="c-modal__content u-no-pt">
			<div class="c-card c-card--height-fit" style="box-shadow:none;">
				<form name="vm.form" class="c-form u-ost-md">
					<div class="o-grid o-grid--wrap">
						<div class="o-grid__cell o-grid__cell--w-100 u-no-p">
							<div style="padding-bottom: 20px;" *ngIf="!vm.targetOrigin || !vm.startTime">
								<item-notification icon="attention" [text]="'Booking.Modal.FeatureDescription' | translate" [theme]="5">
								</item-notification>
							</div>
							<div class="c-form__group u-osb-lg"
								[ngClass]="{ 'c-form__group--error': vm.submitted && !vm.startTime }">
								<label for="startTime" class="c-form__label c-form__label">{{ 'Booking.Modal.StartTime' | translate }} *</label>
								<div id="startTime" *ngIf="vm.initialized">
									<input-datepicker-new 
										id="activation"
										name="startTime" 
										[(model)]="vm.startTime"
										[minDate]="vm.minDate" 
										data-el-parent="datePickerContainer"
										[hasTimepicker]="true" 
										[hasCalendarIcon]="true"
										[isSingleDate]="true" 
										[isFixedPosition]="true"
										[isRequired]="true">
									</input-datepicker-new>
								</div>
							</div>
							<div class="c-form__group u-osb-lg"
								[ngClass]="{ 'c-form__group--error': vm.submitted && !vm.targetOrigin }">
								<label for="targetPlatform" class="c-form__label c-form__label">
									{{ 'Booking.Modal.TargetPlatform' | translate }} *
								</label>
								<mat-select id="targetPlatform" name="targetPlatform" *ngIf="vm.origins" class="mat-select mat-select--border" [(value)]="vm.targetOrigin" required>
									<mat-option id="origin{{$index}}" *ngFor="let origin of vm.origins ; let $index=index" [value]="origin">{{ origin }}</mat-option>
								</mat-select>
							</div>
						</div>
					</div>
					<div class="c-panel u-no-p u-ost-sm u-osb-sm" style="margin-bottom: 150px !important;">
						<button 
							type="button" 
							id="submitReservedTimeButton"
							(click)="vm.submit()"
							[disabled]="vm.processing || !vm.initialized"
							class="c-button c-button--s2 c-button--narrow c-button--fit u-no-wrap">
							{{ (vm.mode === 'CREATE' ? 'Modal.Button.Create' : 'Modal.Button.Update') | translate }}
						</button>
					</div>
				</form>
				<loader-overlay *ngIf="vm.processing || !vm.initialized"></loader-overlay>
			</div>
		</div>
	</div>
</div>
